import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Container, Accordion } from 'react-bootstrap'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  render() {

    const { ajax_data } = this.props

    if(ajax_data != null && 'qwestions_ng' in ajax_data) return (
      <div className={styles.qwestionsng}>
        <Container>
          <div className={styles.qwestionsng_title}>ЧАСТЫЕ ВОПРОСЫ:</div>
          <Accordion defaultActiveKey={0} flush>
            {ajax_data.qwestions_ng.map((elm, i) => {
              return (
                <Accordion.Item key={i} eventKey={i}>
                  <Accordion.Header>{elm.name}</Accordion.Header>
                  <Accordion.Body dangerouslySetInnerHTML={{__html: elm.text}} />
                </Accordion.Item>
              )
            })}
          </Accordion>
        </Container>
      </div>
    )
  }
}

Main.propTypes = {
  ajax_data: PropTypes.object
}